import FillInTheBlankSkillScore from './FillInTheBlankSkillScore';

export default FillInTheBlankSkillScore;
